import { useEffect, useState } from 'react';

export function formatResendWait(seconds: number): string {
  return seconds < 60 ? `${seconds}s` : `${Math.ceil(seconds / 60)} min`;
}

/**
 * Seconds until a new code can be requested, counting down once a second. Each new
 * `response` restarts the countdown from its `seconds`, even when the wait is unchanged,
 * because every send answers with the wait that the server set.
 */
export function useResendCountdown(seconds: number, response: unknown): number {
  const [countdownResponse, setCountdownResponse] = useState(response);
  const [wait, setWait] = useState(seconds);

  if (response !== countdownResponse) {
    setCountdownResponse(response);
    setWait(seconds);
  }

  useEffect(() => {
    if (wait <= 0) {
      return;
    }

    const timer = window.setTimeout(() => setWait((remaining) => remaining - 1), 1_000);

    return () => window.clearTimeout(timer);
  }, [wait]);

  return wait;
}
